import { deserializeSelection } from 'packages/ui/Arborist/utils'

export const serializeContact = (contact) => {
  return {
    sf_id: contact.sf_id,
    confirm: contact.confirm,
    center_user_id: contact.center_user_id,
    admin: contact.admin,
    salutation: contact.salutation,
    last_name: contact.last_name,
    first_name: contact.first_name,
    email: contact.email,
    title: contact.title,
    langue: contact.langue,
    country: contact.country,
    mobile_phone: contact.mobile_phone,
    phone: contact.phone,
    roles: contact.roles,
    parent_ids: contact.account_ids.parent_ids,
    site_ids: contact.account_ids.site_ids,
    two_fa_activated: contact.two_fa_activated
  }
}
export const deserializeContact = (contact) => {
  return {
    sf_id: contact.sf_id,
    center_user_id: contact.center_user_id,
    admin: contact.admin || false,
    salutation: contact.salutation || '',
    last_name: contact.last_name || '',
    first_name: contact.first_name || '',
    email: contact.email || '',
    internal: contact.internal,
    title: contact.title || '',
    country: contact.country || '',
    langue: contact.langue || '',
    mobile_phone: contact.mobile_phone || '',
    phone: contact.phone || '',
    roles: {
      ...contact.roles,
      admin: contact.admin || false
    },
    account_ids: contact.accounts ? deserializeSelection(contact.accounts) : {parent_ids: [], site_ids: []},
    accounts: contact.accounts || [],
    two_fa_activated: contact.two_fa_activated || false
  }
}
